import { useParams } from "react-router-dom";

export const POST_ID_PARAM = "postId";

export const usePostId = () => {
  const { postId } = useParams();
  return postId;
};
